import { render } from "./CheckoutSurvey.vue?vue&type=template&id=00e38651"
import script from "./CheckoutSurvey.vue?vue&type=script&lang=js"
export * from "./CheckoutSurvey.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__